import React, { useState, useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "../../assets/css/Softwaredevelopment.css";
import sdIconOne from "../../assets/image/Softwareimg/sd-1.gif";
import sdIconTwo from "../../assets/image/Softwareimg/sd-2.gif";
import sdIconThree from "../../assets/image/Softwareimg/sd-3.gif";
import sdIconFour from "../../assets/image/Softwareimg/sd-4.gif";
import Footer from "../Footer/Footer";
import imgLogo from "../../assets/image/Home/ICON.png";
import img101 from "../../assets/image/Home/img101.png";
import img102 from "../../assets/image/Home/Amazon_Web_Services_Logo.svg.png";
import GameLogo from "../../assets/image/Game_Logo.png";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

import SWIconOne from "../../assets/image/Softwareimg/sw-icon-1.png";
import SWIconTwo from "../../assets/image/Softwareimg/sw-icon-2.png";
import SWIconThree from "../../assets/image/Softwareimg/sw-icon-3.png";
import SWIconFour from "../../assets/image/Softwareimg/sw-icon-4.png";
import SWIconFive from "../../assets/image/Softwareimg/sw-icon-5.png";
import SWIconSix from "../../assets/image/Softwareimg/sw-icon-6.png";
import SwBgOne from "../../assets/image/Softwareimg/sw-bg-1.jpg";
import { Helmet, HelmetProvider } from "react-helmet-async";
import data from "../../Meta/Meta_ApiUrl";

const SoftwareDevelopment = () => {
  const [meta, setMeta] = useState({});
  useEffect(() => {
    const software = data[0]?.services_page_software;
    if (software) {
      setMeta(software);
    }
  }, []);
  const boxingServices = [
    {
      id: 1,
      title: "Custom Software Development",
      icon: SWIconOne,
      image: SwBgOne,
      description:
        "Tailored software solutions built to meet your specific business requirements and workflows.",
      features: [
        "Bespoke Applications",
        "Business Process Automation",
        "Legacy System Modernization",
        "Integration Solutions",
      ],
    },
    {
      id: 2,
      title: "Web Application Development",
      icon: SWIconTwo,
      image: SwBgOne,
      description:
        "Scalable and responsive web applications using modern frameworks and technologies.",
    },
    {
      id: 3,
      title: "Mobile App Development",
      icon: SWIconThree,
      image: SwBgOne,
      description:
        "Native and cross-platform mobile applications for iOS and Android platforms.",
    },
    {
      id: 4,
      title: "Cloud Solutions",
      icon: SWIconFour,
      image: SwBgOne,
      description:
        "Cloud-native applications and migration services for scalable and reliable systems.",
    },
    {
      id: 5,
      title: "Enterprise Software",
      icon: SWIconFive,
      image: SwBgOne,
      description:
        "Robust enterprise-grade solutions for large-scale business operations.",
    },
    {
      id: 6,
      title: "API Development",
      icon: SWIconSix,
      image: SwBgOne,
      description:
        "RESTful APIs and microservices for seamless system integration and data exchange.",
    },
  ];

  const [hoveredCard, setHoveredCard] = useState(null);
  const [visibleSections, setVisibleSections] = useState({});
  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls to top-left corner
  }, []);

  // Initialize AOS
  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: "ease-in-out",
      once: true,
      mirror: false,
    });
  }, []);

  const developmentServices = [
    {
      id: 1,
      icon: "🖥️",
      title: "Custom Software Development",
      description:
        "Tailored software solutions built to meet your specific business requirements and workflows.",
      features: [
        "Bespoke Applications",
        "Business Process Automation",
        "Legacy System Modernization",
        "Integration Solutions",
      ],
    },
    {
      id: 2,
      icon: "🌐",
      title: "Web Application Development",
      description:
        "Scalable and responsive web applications using modern frameworks and technologies.",
      features: [
        "Single Page Applications",
        "Progressive Web Apps",
        "E-commerce Platforms",
        "Content Management Systems",
      ],
    },
    {
      id: 3,
      icon: "📱",
      title: "Mobile App Development",
      description:
        "Native and cross-platform mobile applications for iOS and Android platforms.",
      features: [
        "Native iOS & Android",
        "Cross-platform Solutions",
        "Hybrid Applications",
        "App Store Optimization",
      ],
    },
    {
      id: 4,
      icon: "☁️",
      title: "Cloud Solutions",
      description:
        "Cloud-native applications and migration services for scalable and reliable systems.",
      features: [
        "Cloud Migration",
        "Microservices Architecture",
        "Serverless Computing",
        "DevOps Integration",
      ],
    },
    {
      id: 5,
      icon: "🛡️",
      title: "Enterprise Software",
      description:
        "Robust enterprise-grade solutions for large-scale business operations.",
      features: [
        "ERP Systems",
        "CRM Solutions",
        "Business Intelligence",
        "Workflow Management",
      ],
    },
    {
      id: 6,
      icon: "🔧",
      title: "API Development",
      description:
        "RESTful APIs and microservices for seamless system integration and data exchange.",
      features: [
        "RESTful APIs",
        "GraphQL Services",
        "Third-party Integrations",
        "API Documentation",
      ],
    },
  ];

  const developmentProcess = [
    {
      step: "01",
      title: "Requirements Analysis",
      description:
        "In-depth analysis of your business requirements and existing systems to create a comprehensive development plan.",
      icon: "📋",
    },
    {
      step: "02",
      title: "Design & Architecture",
      description:
        "Creating detailed system architecture and user interface designs that align with your business goals.",
      icon: "🎯",
    },
    {
      step: "03",
      title: "Development & Testing",
      description:
        "Agile development with continuous integration, automated testing, and quality assurance protocols.",
      icon: "💻",
    },
    {
      step: "04",
      title: "Deployment & Support",
      description:
        "Seamless deployment to production environment with ongoing maintenance and technical support.",
      icon: "🚀",
    },
  ];

  const technologyDomains = {
    frontend: [
      {
        name: "React",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg",
      },
      {
        name: "Vue.js",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vuejs/vuejs-original.svg",
      },
      {
        name: "Angular",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/angularjs/angularjs-original.svg",
      },
      {
        name: "Next.js",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nextjs/nextjs-original.svg",
      },
      {
        name: "TypeScript",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/typescript/typescript-original.svg",
      },
      {
        name: "Tailwind",
        icon: img101,
      },
    ],
    backend: [
      {
        name: "Node.js",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg",
      },
      {
        name: "Python",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg",
      },
      {
        name: "Java",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/java/java-original.svg",
      },
      {
        name: "Express",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/express/express-original.svg",
      },
      {
        name: "Spring",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/spring/spring-original.svg",
      },
      {
        name: "Django",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/django/django-plain.svg",
      },
    ],
    database: [
      {
        name: "MongoDB",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg",
      },
      {
        name: "PostgreSQL",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/postgresql/postgresql-original.svg",
      },
      {
        name: "MySQL",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mysql/mysql-original.svg",
      },
      {
        name: "Redis",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/redis/redis-original.svg",
      },
      {
        name: "Firebase",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/firebase/firebase-plain.svg",
      },
      {
        name: "Oracle",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/oracle/oracle-original.svg",
      },
    ],
    devops: [
      {
        name: "Docker",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/docker/docker-original.svg",
      },
      {
        name: "Kubernetes",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/kubernetes/kubernetes-plain.svg",
      },
      {
        name: "AWS",
        icon: img102,
      },
      {
        name: "Jenkins",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/jenkins/jenkins-original.svg",
      },
      {
        name: "Git",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-original.svg",
      },
      {
        name: "Linux",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/linux/linux-original.svg",
      },
    ],
  };

  const sections = [
    {
      title: "Backend Technologies",
      image: sdIconOne,
      items: [
        "Python frameworks: Django, Flask",
        "Enterprise solutions with Java (Spring Boot)",
        "Secure and scalable solutions using .NET",
        "Event-driven applications with Node.js",
      ],
      domain: "backend",
    },
    {
      title: "Front-End Technologies",
      image: sdIconTwo,
      items: [
        "Modern JavaScript frameworks like Angular, ReactJS, Vue.js",
        "Standards-compliant HTML5 and CSS3",
      ],
      domain: "frontend",
    },
    {
      title: "Development Best Practices",
      image: sdIconThree,
      items: [
        "Iterative development and continuous integration",
        "Rigorous quality assurance and automated testing",
        "Clean coding practices, strong security protocols, and scalable architectures",
      ],
      domain: "devops",
    },
    {
      title: "Database",
      image: sdIconFour,
      items: [
        "MySQL: Fast, reliable, open-source relational database for structured data.",
        "PostgreSQL: Powerful, extensible, SQL-compliant object-relational database.",
        "MongoDB: Flexible NoSQL database for scalable, high-performance applications.",
      ],
      domain: "database",
    },
  ];

  const [currentDomain, setCurrentDomain] = useState(sections[0].domain);
  const [animationKey, setAnimationKey] = useState(0);
  const [openIndex1, setopenIndex1] = useState(0);

  const toggleIndex1 = (index) => {
    setopenIndex1(openIndex1 === index ? null : index);
    setCurrentDomain(sections[index].domain);
    setAnimationKey((prev) => prev + 1);
  };

  const getDomainColor = (domain) => {
    const colors = {
      frontend: { bg: "#ffffff", border: "#ffffff", text: "text-dark" },
      backend: { bg: "#ffffff", border: "#ffffff", text: "text-dark" },
      database: { bg: "#ffffff", border: "#ffffff", text: "text-dark" },
      devops: { bg: "#ffffff", border: "#ffffff", text: "text-dark" },
    };
    return colors[domain] || colors.frontend;
  };

  const getDomainName = (domain) => {
    const names = {
      frontend: "Frontend Development",
      backend: "Backend Development",
      database: "Database Management",
      devops: "DevOps & Cloud",
    };
    return names[domain] || "Frontend Development";
  };

  const currentTechs = technologyDomains[currentDomain];
  const domainColors = getDomainColor(currentDomain);

  // const sections = [
  //   {
  //     title: "Backend Technologies",
  //     image: sdIconOne,
  //     items: [
  //       "Python frameworks: Django, Flask",
  //       "Enterprise solutions with Java (Spring Boot)",
  //       "Secure and scalable solutions using .NET",
  //       "Event-driven applications with Node.js",
  //     ],
  //   },
  //   {
  //     title: "Front-End Technologies",
  //     image: sdIconTwo,
  //     items: [
  //       "Modern JavaScript frameworks like Angular, ReactJS, Vue.js",
  //       "Standards-compliant HTML5 and CSS3",
  //     ],
  //   },
  //   {
  //     title: "Development Best Practices",
  //     image: sdIconThree,
  //     items: [
  //       "Iterative development and continuous integration",
  //       "Rigorous quality assurance and automated testing",
  //       "Clean coding practices, strong security protocols, and scalable architectures",
  //     ],
  //   },
  //   {
  //     title: "Database",
  //     image: sdIconFour,
  //     items: [
  //       "MySQL : MySQL is a fast, reliable, and widely used open-source relational database management system for storing and managing structured data.",
  //       "PostgreSQL : PostgreSQL is a powerful, open-source object-relational database system known for its advanced features, extensibility, and SQL compliance.",
  //       "MongoDB : MongoDB is a flexible, open-source NoSQL database that stores data in JSON-like documents, enabling scalable and high-performance applications.",
  //       "Redis : Redis is an open-source, in-memory data structure store used as a database, cache, and message broker for high-speed data operations.",
  //     ],
  //   },
  // ];

  // const sections = [
  //   {
  //     title: "Frontend Development",
  //     image: "https://via.placeholder.com/80x80/667eea/ffffff?text=⚛️",
  //     items: ["React.js", "Vue.js", "Angular", "TypeScript", "Tailwind CSS"],
  //     gradient: "linear-gradient(135deg, #00b7eb, #00b7eb)",
  //     icon: "🎨",
  //   },
  //   {
  //     title: "Backend Development",
  //     image: "https://via.placeholder.com/80x80/f093fb/ffffff?text=⚙️",
  //     items: ["Node.js", "Python", "Java", "PHP", "Express.js"],
  //     gradient: "linear-gradient(135deg, #00b7eb, #00b7eb)",
  //     icon: "⚙️",
  //   },
  //   {
  //     title: "Database Management",
  //     image: "https://via.placeholder.com/80x80/4facfe/ffffff?text=🗄️",
  //     items: ["MongoDB", "PostgreSQL", "MySQL", "Redis", "Firebase"],
  //     gradient: "linear-gradient(135deg, #00b7eb, #00b7eb)",
  //     icon: "🗄️",
  //   },
  //   {
  //     title: "Cloud & DevOps",
  //     image: "https://via.placeholder.com/80x80/43e97b/ffffff?text=☁️",
  //     items: ["AWS", "Docker", "Kubernetes", "CI/CD", "Terraform"],
  //     gradient: "linear-gradient(135deg, #00b7eb, #00b7eb)",
  //     icon: "☁️",
  //   },
  // ];

  // Responsive column calculation
  // const getColumnsPerRow = () => {
  //   if (window.innerWidth >= 1200) return 4;
  //   if (window.innerWidth >= 992) return 3;
  //   if (window.innerWidth >= 768) return 2;
  //   return 1;
  // };

  // const [columnsPerRow, setColumnsPerRow] = useState(getColumnsPerRow());

  // useEffect(() => {
  //   const handleResize = () => {
  //     setColumnsPerRow(getColumnsPerRow());
  //   };

  //   window.addEventListener("resize", handleResize);
  //   return () => window.removeEventListener("resize", handleResize);
  // }, []);

  const [openIndex, setOpenIndex] = useState(0);

  const toggleIndex = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  //techonology
  // const technologyDomains = {
  //   frontend: [
  //     {
  //       name: "React",
  //       icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg",
  //     },
  //     {
  //       name: "Vue.js",
  //       icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vuejs/vuejs-original.svg",
  //     },
  //     {
  //       name: "Angular",
  //       icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/angularjs/angularjs-original.svg",
  //     },
  //     {
  //       name: "Next.js",
  //       icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nextjs/nextjs-original.svg",
  //     },
  //     {
  //       name: "TypeScript",
  //       icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/typescript/typescript-original.svg",
  //     },
  //     {
  //       name: "Tailwind",
  //       icon: img101,
  //     },
  //   ],
  //   backend: [
  //     {
  //       name: "Node.js",
  //       icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg",
  //     },
  //     {
  //       name: "Python",
  //       icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg",
  //     },
  //     {
  //       name: "Java",
  //       icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/java/java-original.svg",
  //     },
  //     {
  //       name: "Express",
  //       icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/express/express-original.svg",
  //     },
  //     {
  //       name: "Spring",
  //       icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/spring/spring-original.svg",
  //     },
  //     {
  //       name: "Django",
  //       icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/django/django-plain.svg",
  //     },
  //   ],
  //   database: [
  //     {
  //       name: "MongoDB",
  //       icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg",
  //     },
  //     {
  //       name: "PostgreSQL",
  //       icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/postgresql/postgresql-original.svg",
  //     },
  //     {
  //       name: "MySQL",
  //       icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mysql/mysql-original.svg",
  //     },
  //     {
  //       name: "Redis",
  //       icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/redis/redis-original.svg",
  //     },
  //     {
  //       name: "Firebase",
  //       icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/firebase/firebase-plain.svg",
  //     },
  //     {
  //       name: "Oracle",
  //       icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/oracle/oracle-original.svg",
  //     },
  //   ],
  //   devops: [
  //     {
  //       name: "Docker",
  //       icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/docker/docker-original.svg",
  //     },
  //     {
  //       name: "Kubernetes",
  //       icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/kubernetes/kubernetes-plain.svg",
  //     },
  //     {
  //       name: "AWS",
  //       icon: img102,
  //     },
  //     {
  //       name: "Jenkins",
  //       icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/jenkins/jenkins-original.svg",
  //     },
  //     {
  //       name: "Git",
  //       icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-original.svg",
  //     },
  //     {
  //       name: "Linux",
  //       icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/linux/linux-original.svg",
  //     },
  //   ],
  // };

  // const [currentDomain, setCurrentDomain] = useState("frontend");
  // const [animationKey, setAnimationKey] = useState(0);

  // useEffect(() => {
  //   const domains = Object.keys(technologyDomains);
  //   const interval = setInterval(() => {
  //     setCurrentDomain((prev) => {
  //       const currentIndex = domains.indexOf(prev);
  //       const nextIndex = (currentIndex + 1) % domains.length;
  //       return domains[nextIndex];
  //     });
  //     setAnimationKey((prev) => prev + 1);
  //   }, 3000);

  //   return () => clearInterval(interval);
  // }, []);

  // const getDomainColor = (domain) => {
  //   const colors = {
  //     frontend: { bg: "bg-white", border: "border-white", text: "text-dark" },
  //     backend: { bg: "bg-white", border: "border-white", text: "text-dark" },
  //     database: { bg: "bg-white", border: "border-white", text: "text-dark" },
  //     devops: { bg: "bg-white", border: "border-white", text: "text-dark" },
  //   };
  //   return colors[domain] || colors.frontend;
  // };

  // const getDomainName = (domain) => {
  //   const names = {
  //     frontend: "Frontend Development",
  //     backend: "Backend Development",
  //     database: "Database Management",
  //     devops: "DevOps & Cloud",
  //   };
  //   return names[domain];
  // };

  // const currentTechs = technologyDomains[currentDomain];
  // const domainColors = getDomainColor(currentDomain);

  return (
    <HelmetProvider>
      <div>
        <Helmet>
          <title>
            {meta?.title || "Services-Software_Development  - SHIV NXTGEN TECHNOLOGIES PRIVATE LIMITED"}
          </title>
          <meta
            name="description"
            content={meta?.meta?.meta1?.content || "Our curriculum."}
          />
        </Helmet>
        {/* Hero Section */}
        <div
          className="position-relative min-vh-50 software-bg d-flex align-items-center justify-content-center bg-dark text-white"
          data-aos="fade-in"
          data-aos-duration="1000"
        >
          <div className="position-absolute top-0 start-0 w-100 h-100 opacity-20"></div>
          <div className="container position-relative">
            <div className="row align-items-center">
              <div
                className="col-lg-6 software-content"
                data-aos="fade-right"
                data-aos-delay="200"
              >
                <nav aria-label="breadcrumb" className="mb-4">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <a
                        href="/"
                        className="text-white fw-bold text-decoration-none"
                      >
                        Home
                      </a>
                    </li>
                    <li
                      className="text-white fw-bold breadcrumb-item"
                      aria-current="page"
                    >
                      Software Development
                    </li>
                  </ol>
                </nav>
                <h3 className="display-5 fw-bold mb-3">Software Development</h3>
              </div>
            </div>
          </div>
        </div>

        {/* Slider */}
        <section
          className="py-2 bg-animated bg-scroll-animated mt-3 d-flex align-items-center"
          style={{ minHeight: "40vh" }}
        >
          <div className="container text-start">
            <h3 className="display-5 font-black fw-bold">
              Software <span className="font-red">Development</span>
            </h3>
            <p className="mb- font-para">
              Comprehensive software development solutions tailored to your
              business needs
            </p>

            <div className="position-relative mt-2">
              <Swiper
                modules={[Navigation, Autoplay]}
                navigation
                loop
                autoplay={{ delay: 3000 }}
                spaceBetween={30}
                slidesPerView={1}
                breakpoints={{
                  768: { slidesPerView: 2 },
                  992: { slidesPerView: 3 },
                }}
                className="mySwiper p-5  bg-transparent"
              >
                {boxingServices.map((service) => (
                  <SwiperSlide key={service.id}>
                    <div
                      className="boxing-card position-relative rounded-4 p-4"
                      style={{ width: "100%", height: "300px" }}
                    >
                      <div className="text-center">
                        <img
                          src={service.icon}
                          alt={service.title}
                          style={{ height: "60px", color: "#00b7eb" }}
                        />
                        <h2 className="fw-bold font-black mt-4">
                          {service.title}
                        </h2>
                        <p className="fs-6 fw-semibold">
                          {service.description}
                        </p>
                        {/* <ul className="list-unstyled">
                        {service.features.map((feature, id1) => (
                          <li
                            key={id1}
                            className="d-flex align-items-center mb-2 font-lack fw-medium"
                          >
                            <span
                              className="me-2 font-red"
                              style={{ fontWeight: "800" }}
                            >
                              ✓
                            </span>
                            <small>{feature}</small>
                          </li>
                        ))}
                      </ul> */}
                      </div>

                      <div
                        className="hover-overlay d-flex flex-column justify-content-center align-items-center text-white text-center"
                        style={{ backgroundImage: `url(${service.image})` }}
                      >
                        {/* <h5 className="fw-bold d-flex align-items-start mb-3">{service.title} TRAINING</h5> */}
                        <button className="btn btn-outline-light mt-5">
                          Show Details <span className="ms-1">→</span>
                        </button>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        </section>

        {/* Section 1: Core Development Services */}
        <section className="py-2" data-aos="fade-up">
          <div className="container">
            <div className="text-center mb-2">
              <h3 className="display-5 fw-bold font-red">
                Development <span className="font-black">Services</span>
              </h3>
              <p className="font-para">
                Comprehensive software development solutions tailored to your
                business needs
              </p>
            </div>

            <div className="row g-4">
              {developmentServices.map((service, index) => (
                <div
                  key={service.id}
                  className="col-lg-4 col-md-6"
                  data-aos="fade-up"
                  data-aos-delay={index * 300}
                  data-aos-duration="800"
                >
                  <div
                    className="bg-white rounded-4 p-4 shadow-sm h-100 position-relative transition-transform"
                    style={{
                      transition: "transform 0.3s ease, box-shadow 0.3s ease",
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.transform = "scale(1.02)")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.transform = "scale(1)")
                    }
                  >
                    <div className="d-flex align-items-center mb-3">
                      <div
                        className="rounded-circle d-flex align-items-center justify-content-center me-3"
                        style={{
                          width: "50px",
                          height: "50px",
                          backgroundColor: "#f2f2f2",
                          fontSize: "1.5rem",
                        }}
                      >
                        {service.icon}
                      </div>
                      <h3 className="fw-bold   font-card-heading font-red mb-0">
                        {service.title}
                      </h3>
                    </div>

                    <p className="font-para  mb-4">{service.description}</p>

                    <ul className="list-unstyled">
                      {service.features.map((feature, idx) => (
                        <li
                          key={idx}
                          className="d-flex align-items-center mb-2 font-lack fw-medium"
                        >
                          <span
                            className="me-2 text-danger"
                            style={{ fontWeight: "800" }}
                          >
                            ✓
                          </span>
                          <div className="font-card-features fw-medium">
                            {feature}
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section>
          <div className="container py-4">
            <div className="d-flex justify-content-center align-items-center text-center px-3">
              <div>
                <h3 className="display-5 fw-bold font-red mb-3">
                  <span className="font-black">Technologies</span> & Tools
                </h3>
                <p className="font-para mb-4">
                  Cutting-edge technology stack for robust and scalable
                  solutions
                </p>
              </div>
            </div>

            <div className="row">
              <div className="col-md-6">
                {sections.map((section, index) => (
                  <div key={index} className="accordion-section mb-3">
                    <button
                      className="accordion-title"
                      onClick={() => toggleIndex1(index)}
                      aria-expanded={openIndex1 === index}
                      aria-controls={`accordion-content-${index}`}
                    >
                      <div className="title-with-icon">
                        <img
                          src={section.image}
                          alt={`${section.title} icon`}
                          className="section-icon"
                        />
                        <span>{section.title}</span>
                      </div>
                      <span
                        className={`arrow ${
                          openIndex1 === index ? "open" : ""
                        }`}
                      >
                        ▶
                      </span>
                    </button>
                    <div
                      id={`accordion-content-${index}`}
                      className={`accordion-content ${
                        openIndex1 === index ? "open" : ""
                      }`}
                    >
                      <ul>
                        {section.items.map((item, idx) => (
                          <li key={idx}>{item}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                ))}
              </div>

              <div className="col-md-6" style={{ marginTop: "40px" }}>
                <div className="row g-4 justify-content-center">
                  {currentTechs.slice(0, 3).map((tech, index) => (
                    <div key={`card-${index}`} className="col-4 col-md-4">
                      <div
                        className="card border-0 shadow-sm h-100 bg-white border-2 border-light"
                        style={{ minHeight: "150px" }}
                      >
                        <div className="card-body d-flex align-items-center justify-content-center p-3">
                          <img
                            key={`${currentDomain}-${tech.name}-${index}-${animationKey}`}
                            src={tech.icon}
                            alt={`${tech.name} icon`}
                            className="img-fluid"
                            style={{
                              width: "48px",
                              height: "48px",
                              objectFit: "contain",
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  ))}

                  <div className="col-8 col-md-8">
                    <div
                      className={`card border-0 shadow h-100 ${domainColors.bg} text-white position-relative overflow-hidden`}
                      style={{ minHeight: "150px" }}
                    >
                      <div className="card-body d-flex align-items-center justify-content-center p-4">
                        <div className="text-center">
                          <h5 className="fs-3 mb-0 fw-bold text-danger text-uppercase letter-spacing-wide">
                            {getDomainName(currentDomain)}
                          </h5>
                        </div>
                      </div>
                      <div className="position-absolute top-0 end-0 p-2">
                        <div
                          className="bg-white bg-opacity-20 rounded-circle"
                          style={{ width: "8px", height: "8px" }}
                        ></div>
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-sm-6 col-md-4 mb-4">
                    <div className="card border-0 shadow-sm h-100 bg-white border border-secondary">
                      <div className="card-body d-flex align-items-center justify-content-center p-3">
                        <div className="rounded-circle d-flex align-items-center justify-content-center bg-white">
                          <img
                            src={GameLogo}
                            alt="Game Logo"
                            className="img-fluid"
                            style={{ maxWidth: "70%", height: "auto" }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  {currentTechs.slice(3, 6).map((tech, index) => (
                    <div key={`card-${index + 3}`} className="col-4 col-md-4">
                      <div
                        className="card border-0 shadow-sm h-100 bg-white border-2 border-light"
                        style={{ minHeight: "150px" }}
                      >
                        <div className="card-body d-flex align-items-center justify-content-center p-3">
                          <img
                            key={`${currentDomain}-${tech.name}-${
                              index + 3
                            }-${animationKey}`}
                            src={tech.icon}
                            alt={`${tech.name} icon`}
                            className="img-fluid"
                            style={{
                              width: "48px",
                              height: "48px",
                              objectFit: "contain",
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Section 2: Technologies & Tools */}
        {/* <div className="container py-4">
        <div className="d-flex justify-content-center align-items-center text-center px-3">
          <div>
            <h3 className="display-5 fw-bold font-red mb-3">
              <span className="font-black">Technologies</span> & Tools
            </h3>
            <p className="font-para mb-4">
              Cutting-edge technology stack for robust and scalable solutions
            </p>
          </div>
        </div>

        <div className="row">
          <div className="col-6">
            {sections.map((section, index) => {
              const durations = [700, 900, 1000, 1200];
              return (
                <div
                  key={index}
                  className="accordion-section"
                  data-aos="fade-right"
                  data-aos-duration={durations[index] || 800}
                >
                  <button
                    className="accordion-title"
                    onClick={() => toggleIndex(index)}
                  >
                    <div className="title-with-icon">
                      <img
                        src={section.image}
                        alt="icon"
                        className="section-icon"
                      />
                      <span>{section.title}</span>
                    </div>
                    <span
                      className={`arrow ${openIndex === index ? "open" : ""}`}
                    >
                      ▶
                    </span>
                  </button>
                  <div
                    className={`accordion-content ${
                      openIndex === index ? "open" : ""
                    }`}
                  >
                    <ul>
                      {section.items.map((item, idx) => (
                        <li key={idx}>{item}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              );
            })}
          </div>
          <div className="col-6" style={{marginTop:'40px'}}>
            <div className="row g-4 justify-content-center">
              
              {currentTechs.slice(0, 3).map((tech, index) => (
                <div key={`card-${index}`} className="col-4 col-md-4">
                  <div
                    className="card border-0 shadow-sm h-100 bg-white border-2 border-light"
                    style={{ minHeight: "150px" }}
                  >
                    <div className="card-body d-flex align-items-center justify-content-center p-3">
                      <img
                        key={`${currentDomain}-${tech.name}-${index}-${animationKey}`}
                        src={tech.icon}
                        alt={tech.name}
                        className="img-fluid"
                        style={{
                          width: "48px",
                          height: "48px",
                          objectFit: "contain",
                          animation: `slideUpFade 0.6s ease-out ${
                            index * 0.1
                          }s both`,
                        }}
                      />
                    </div>
                  </div>
                </div>
              ))}

              
              <div className="col-8 col-md-8">
                <div
                  className={`card border-0 shadow h-100 ${domainColors.bg} text-white position-relative overflow-hidden`}
                  style={{ minHeight: "150px" }}
                >
                  <div className="card-body d-flex align-items-center justify-content-center p-4">
                    <div className="text-center">
                      <h5 className="fs-3 mb-0 fw-bold text-danger text-uppercase letter-spacing-wide">
                        {getDomainName(currentDomain)}
                      </h5>
                    </div>
                  </div>
                  <div className="position-absolute top-0 end-0 p-2">
                    <div
                      className="bg-white bg-opacity-20 rounded-circle"
                      style={{ width: "8px", height: "8px" }}
                    ></div>
                  </div>
                </div>
              </div>

              <div className="col-4 col-md-4">
                <div
                  className="card border-0 shadow-sm h-100 bg-white border-2 border-secondary"
                  style={{ minHeight: "150px" }}
                >
                  <div className="card-body d-flex align-items-center justify-content-center p-3">
                    <div className=" text-white rounded-circle d-flex align-items-center justify-content-center">
                      <img
                        src={imgLogo}
                        style={{ width: "50px", height: "50px" }}
                      />
                      <h6></h6>
                    </div>
                  </div>
                </div>
              </div>

              {currentTechs.slice(3, 6).map((tech, index) => (
                <div key={`card-${index + 3}`} className="col-4 col-md-4">
                  <div
                    className="card border-0 shadow-sm h-100 bg-white border-2 border-light"
                    style={{ minHeight: "150px" }}
                  >
                    <div className="card-body d-flex align-items-center justify-content-center p-3">
                      <img
                        key={`${currentDomain}-${tech.name}-${
                          index + 3
                        }-${animationKey}`}
                        src={tech.icon}
                        alt={tech.name}
                        className="img-fluid"
                        style={{
                          width: "48px",
                          height: "48px",
                          objectFit: "contain",
                          animation: `slideUpFade 0.6s ease-out ${
                            (index + 3) * 0.1
                          }s both`,
                        }}
                      />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div> */}

        {/* <div className="premium-gradient-bg py-5">
        <div className="container">
      
          <div className="row">
            <div className="col-12">
              <div className="text-center px-3 mb-5">
                <h3 className="display-5 fw-bold font-red mb-3">
                  <span className="font-black">Technologies</span> & Tools
                </h3>
                <p
                  className="font-para text-dark-50 mb-4 fs-5"
                  style={{
                    textShadow: "0 1px 10px rgba(0,0,0,0.2)",
                    maxWidth: "600px",
                    margin: "0 auto",
                  }}
                >
                  Cutting-edge technology stack for robust and scalable
                  solutions
                </p>
              </div>
            </div>
          </div>

         
          <div className="row justify-content-center">
            {sections.map((section, index) => (
              <div
                key={index}
                className={`col-12 col-md-${12 / columnsPerRow} `}
              >
                <div className="premium-card rounded-4  position-relative">
                 
                  <div 
                        className="rounded-3  text-center position-relative overflow-hidden"
                        style={{ 
                          background: section.gradient,
                          minHeight: '70px',
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'center',
                          alignItems: 'center'
                        }}
                      >
                        <div className="premium-icon rounded-circle d-flex align-items-center justify-content-center " 
                             style={{ 
                               width: '60px', 
                               height: '60px',
                               background: 'rgba(255,255,255,0.2)',
                               backdropFilter: 'blur(10px)',
                               fontSize: '24px'
                             }}>
                          {section.icon}
                        </div>
                        <h4 className="fw-bold text-white mb-0 fs-5" style={{ 
                          textShadow: '0 2px 10px rgba(0,0,0,0.3)',
                          letterSpacing: '1px'
                        }}>
                          {section.title}
                        </h4>
                      </div>
  

                  <div className="d-flex flex-column gap-2 px-3 pb-3">
                    {section.items.map((item, idx) => (
                      <div
                        key={idx}
                        className="premium-item d-flex align-items-center py-2 px-3 rounded-3"
                        style={{
                          background:
                            "linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%)",
                          border: "1px solid rgba(0,0,0,0.05)",
                          cursor: "pointer",
                        }}
                      >
                        <div
                          className="rounded-circle me-3"
                          style={{
                            width: "8px",
                            height: "8px",
                            background: section.gradient,
                          }}
                        ></div>
                        <span className="fw-medium text-dark fs-6">{item}</span>
                        <div className="ms-auto">
                          <i className="bi bi-arrow-right text-muted"></i>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div> */}

        {/* Section 3: Development Process */}
        <section className="py-3 bg-light" data-aos="fade-up">
          <div className="container">
            <div className="row mb-2">
              <div
                className="col-12 text-center"
                data-aos="fade-up"
                data-aos-delay="100"
              >
                <h3 className="display-5 fw-bold font-black mb-3">
                  Development <span className="font-red">Process</span>
                </h3>
                <p className="font-para">
                  Our proven methodology ensures quality delivery and client
                  satisfaction
                </p>
              </div>
            </div>

            <div className="row g-4">
              {developmentProcess.map((process, index) => (
                <div
                  key={index}
                  className="col-lg-3 col-md-6"
                  data-aos="fade-up"
                  data-aos-delay={index * 100}
                >
                  <div className="card border-0 bg-white shadow-lg h-100 position-relative overflow-hidden">
                    <div className="card-body text-center p-4">
                      <div className="position-relative mb-4">
                        <div className="d-flex align-items-center justify-content-center mx-auto mb-3">
                          <span className="fs-1">{process.icon}</span>
                        </div>
                      </div>
                      <h5 className="font-card-heading fw-bold font-red">
                        {process.title}
                      </h5>
                      <p className="font-card-para fw-medium mb-1">
                        {process.description}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Section 5: Call to Action */}
        <section
          className="py-3 bg-light font-black position-relative overflow-hidden"
          data-aos="fade-up"
        >
          <div className="position-absolute top-0 start-0 w-100 h-100 opacity-10"></div>
          <div className="container position-relative">
            <div className="row">
              <div
                className="col-lg-8 mx-auto text-center"
                data-aos="fade-up"
                data-aos-delay="100"
              >
                <h3 className="display-5 font-black fw-bold mb-3">
                  Ready to Build Your <br />
                  <span className="font-red"> Software Solution?</span>
                </h3>
                <p className="font-para mb-4">
                  Let's discuss your project requirements and create a custom
                  software solution that drives your business forward. From
                  concept to deployment, we're your trusted development partner.
                </p>

                <div className="row g-4 mb-5">
                  <div
                    className="col-md-4"
                    data-aos="zoom-in"
                    data-aos-delay="200"
                  >
                    <div className="text-center">
                      <div
                        className="bg-dark rounded-circle d-inline-flex align-items-center justify-content-center mb-3"
                        style={{
                          width: "80px",
                          height: "80px",
                        }}
                      >
                        <span className="fs-2 text-white">🚀</span>
                      </div>
                      <h6 className="font-card-heading fw-bold">
                        Fast Delivery
                      </h6>
                      <p className="font-para fw-semibold">
                        Agile development methodology
                      </p>
                    </div>
                  </div>
                  <div
                    className="col-md-4"
                    data-aos="zoom-in"
                    data-aos-delay="300"
                  >
                    <div className="text-center">
                      <div
                        className="bg-dark rounded-circle d-inline-flex align-items-center justify-content-center mb-3"
                        style={{ width: "80px", height: "80px" }}
                      >
                        <span className="fs-2 font-black">⭐</span>
                      </div>
                      <h6 className="font-card-heading fw-bold">
                        Quality Assured
                      </h6>
                      <p className="font-para fw-semibold">
                        Rigorous testing standards
                      </p>
                    </div>
                  </div>
                  <div
                    className="col-md-4"
                    data-aos="zoom-in"
                    data-aos-delay="400"
                  >
                    <div className="text-center">
                      <div
                        className="bg-dark rounded-circle d-inline-flex align-items-center justify-content-center mb-3"
                        style={{ width: "80px", height: "80px" }}
                      >
                        <span className="fs-2 text-white">🛠️</span>
                      </div>
                      <h6 className="font-card-heading fw-bold">
                        24/7 Support
                      </h6>
                      <p className="font-para fw-semibold">
                        Ongoing maintenance & support
                      </p>
                    </div>
                  </div>
                </div>

                <div
                  className="d-flex flex-column flex-sm-row justify-content-center gap-3"
                  data-aos="fade-up"
                  data-aos-delay="500"
                ></div>
              </div>
            </div>
          </div>
        </section>

        <style>{`
          .tech-card {
            transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
            cursor: pointer;
          }

          .tech-card:hover {
            transform: translateY(-15px) scale(1.02);
            box-shadow: 0 25px 50px rgba(0, 0, 0, 0.2) !important;
          }

          .tech-overlay {
            background: linear-gradient(
              135deg,
              rgba(222, 31, 38, 0.95),
              rgba(5, 7, 8, 0.95),
              rgba(255, 255, 255, 0.95)
            );
            opacity: 0;
            transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
            z-index: 10;
            backdrop-filter: blur(5px);
          }

          .tech-card:hover .tech-overlay {
            opacity: 1;
          }

          .tech-image {
            filter: brightness(0.9) contrast(1.1);
            transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
          }

          .tech-card:hover .tech-image {
            filter: brightness(0.3) contrast(1.2);
            transform: scale(1.15);
          }

          .tech-icon-overlay {
            opacity: 0;
            transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
            z-index: 5;
            transform: scale(0.8);
          }

          .tech-card:hover .tech-icon-overlay {
            opacity: 1;
            transform: scale(1);
          }

          .drop-shadow {
            filter: drop-shadow(2px 2px 4px rgba(0, 0, 0, 0.5));
          }

          .tech-content {
            transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
            position: relative;
            z-index: 1;
          }

          .tech-card:hover .tech-content {
            background: rgba(248, 249, 250, 0.98);
            backdrop-filter: blur(10px);
          }

          .tech-item {
            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            border: 1px solid transparent;
            position: relative;
            overflow: hidden;
          }

          .tech-item::before {
            content: "";
            position: absolute;
            top: 0;
            left: -100%;
            width: 100%;
            height: 100%;
            background: linear-gradient(
              90deg,
              transparent,
              rgba(220, 53, 69, 0.1),
              transparent
            );
            transition: left 0.5s ease;
          }

          .tech-item:hover::before {
            left: 100%;
          }

          .tech-item:hover {
            background: rgba(220, 53, 69, 0.08) !important;
            border-color: rgba(220, 53, 69, 0.3);
            transform: translateX(8px) scale(1.02);
            box-shadow: 0 4px 12px rgba(220, 53, 69, 0.15);
          }

          .tech-image-container {
            overflow: hidden;
            position: relative;
          }

          .tech-image-container::after {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: linear-gradient(
              45deg,
              rgba(223, 70, 86, 0.1),
              rgba(191, 22, 22, 0.1)
            );
            opacity: 0;
            transition: opacity 0.4s ease;
            z-index: 2;
          }

          .tech-card:hover .tech-image-container::after {
            opacity: 1;
          }

          .tech-card:hover .tech-icon-overlay .fs-1 {
            animation: pulse 2s infinite;
          }

          @keyframes pulse {
            0% {
              transform: scale(1);
            }
            50% {
              transform: scale(1.1);
            }
            100% {
              transform: scale(1);
            }
          }

          .card:hover {
            box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1) !important;
          }

          .btn {
            transition: all 0.3s ease;
          }

          .btn:hover {
            transform: translateY(-2px);
          }

          @media (max-width: 768px) {
            .display-3 {
              font-size: 2rem;
            }
            .display-4 {
              font-size: 1.8rem;
            }
            .tech-card:hover {
              transform: translateY(-8px) scale(1.01);
            }
            .tech-item:hover {
              transform: translateX(4px);
            }
          }

          @media (prefers-reduced-motion: reduce) {
            .tech-card,
            .tech-overlay,
            .tech-image,
            .tech-item {
              transition: none !important;
              animation: none !important;
            }
          }
        `}</style>

        <Footer />
      </div>
    </HelmetProvider>
  );
};

export default SoftwareDevelopment;
